import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { blogPosts } from '../data/siteData';
import { useReveal } from '../hooks/useReveal';
import './Inner.css';

function R({ children, className }) { const r = useReveal(); return <div ref={r} className={`reveal ${className||''}`}>{children}</div>; }

export function Blog() {
  return (
    <div>
      <section className="page-hero">
        <div className="ph-orb ph-orb-1" /><div className="ph-orb ph-orb-2" />
        <div className="container page-hero-inner">
          <div className="badge"><div className="badge-dot">✦</div>Insights</div>
          <h1 className="ph-title">From the <span className="teal-text">engineering desk</span></h1>
          <p className="ph-sub">Practical guides and breakdowns from our team — no fluff, just craft.</p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="blog-grid-page">
            {blogPosts.map(post => (
              <R key={post.id}>
                <Link to={`/blog/${post.id}`} className="blog-card-page">
                  <div className="blog-thumb-page" style={{ background: post.thumbBg }}>{post.thumb}</div>
                  <div className="blog-body-page">
                    <div className="blog-cat-page">{post.category}</div>
                    <h2>{post.title}</h2>
                    <p>{post.summary}</p>
                    <div className="blog-meta-page">{post.readTime} · {post.date}</div>
                  </div>
                </Link>
              </R>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export function BlogDetail() {
  const { id } = useParams();
  const post = blogPosts.find(p => p.id === id);
  if (!post) return <Navigate to="/blog" replace />;

  const renderContent = (content) =>
    content.split('\n').map((line, i) => {
      if (line.startsWith('## ')) return <h2 key={i} className="bd-h2">{line.slice(3)}</h2>;
      if (line.startsWith('- '))  return <li key={i} className="bd-li">{line.slice(2)}</li>;
      if (line.startsWith('**') && line.endsWith('**')) return <p key={i} className="bd-bold">{line.slice(2,-2)}</p>;
      if (line.trim() === '')    return <br key={i} />;
      return <p key={i} className="bd-p">{line}</p>;
    });

  return (
    <div>
      <section className="page-hero" style={{ textAlign:'center' }}>
        <div className="ph-orb ph-orb-1" />
        <div className="container page-hero-inner">
          <Link to="/blog" className="back-link">← All posts</Link>
          <div className="blog-hero-thumb" style={{ background: post.thumbBg }}>{post.thumb}</div>
          <div className="blog-cat-page" style={{ marginBottom:12 }}>{post.category}</div>
          <h1 className="ph-title" style={{ maxWidth:700, margin:'0 auto 16px' }}>{post.title}</h1>
          <div className="blog-meta-page">{post.readTime} · {post.date}</div>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="blog-detail-wrap">
            <div className="blog-detail-content">
              {renderContent(post.content)}
            </div>
            <aside className="blog-sidebar">
              <div className="bsb-card">
                <h3>More posts</h3>
                {blogPosts.filter(p=>p.id!==post.id).map(p => (
                  <Link to={`/blog/${p.id}`} key={p.id} className="bsb-post">
                    <span className="bsb-icon" style={{ background: p.thumbBg }}>{p.thumb}</span>
                    <span className="bsb-title">{p.title}</span>
                  </Link>
                ))}
              </div>
              <div className="bsb-cta">
                <h3>Want results like these?</h3>
                <p>Let's discuss your project.</p>
                <Link to="/get-quote" className="btn-grad" style={{ display:'block', textAlign:'center', marginTop:12 }}>Get a free quote →</Link>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </div>
  );
}
